export const imageNames = [
    "birds_rainbow-lorakeets.png",
    "boxer-getting-tan.png",
    "boxer-laying-down.png",
    "butterfly_monarch.png",
    "butterfly.png",
    "cat_squinting.jpg",
    "cat_on_couch.jpg",
    "cat_in_hand.jpg",
    "cat_blue_eyes.jpg",
    "cat_butterfly.jpg",
    "cat_black.jpg",
    "cat_darktabby.jpg",
    "cat_eats_flowers.jpg",
    "cat_in_blankets.jpg",
    "cat_lynx.jpg",
    "cat_on_table.jpg",
    "cat_orange.jpg",
    "cat_tiger.jpg",
    "cat_greygreen.jpg",
    "cat_in_snow.jpg",
    "cat_blackwhite.jpg",
    "cat_leashed.jpg",
    "cat_mean.jpg",
    "cat_mainecoon.jpg",
    "cat_sphynx.jpg",
    "cat_fence.jpg",
    "cat.png",
    "kitten_sits.jpg",
    "cheetah.png",
    "crocodiles.png",
    "dog_sleeping-puppy.png",
    "dog_puppy_eyes.jpg",
    "dog_collie.jpg",
    "fox.png",
    "horse.png",
    "kangaroos.png",
    "komodo-dragon.png",
    "penguins.png",
    "pug_et.jpg",
    "rabbit.png",
    "retriever.png",
    "shark.png",
    "snake_green-tree-boa.png",
    "spider_pet.jpg",
];